import React from 'react';
import { Intent, IntentConfig } from 'src/shared/intent';

export type ConnectIntent = Intent<[number]>;

export const toIntent = (catalogItemId: number): ConnectIntent => new Intent({ action: 'connect', params: [catalogItemId] });

export const isConnectIntent = (intent: Intent): intent is ConnectIntent => intent.action === 'connect';

export const intentConfig: IntentConfig = {
  action: 'connect',
  Component: React.lazy(() => import('./intentRunner')),
};
